import { Drawer, Box, Typography, List, ListItemButton, ListItemText, IconButton, Button } from '@mui/material';
import { X, Plus } from 'lucide-react';
import { ICON_SIZES, ICON_STROKE } from '../../constants/icons';

interface Conversation {
  id: string;
  title: string;
  updatedAt: Date;
}

interface ConversationHistoryDrawerProps {
  open: boolean;
  onClose: () => void;
  conversations: Conversation[];
  currentConversationId: string | null;
  onSelectConversation: (id: string) => void;
  onNewConversation: () => void;
}

export function ConversationHistoryDrawer({ open, onClose, conversations, currentConversationId, onSelectConversation, onNewConversation }: ConversationHistoryDrawerProps) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 320, height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: 2,
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          <Typography variant="h6">Conversations</Typography>
          <IconButton size="small" onClick={onClose}>
            <X size={ICON_SIZES.lg} strokeWidth={ICON_STROKE} />
          </IconButton>
        </Box>

        {/* New Conversation Button */}
        <Box sx={{ p: 2 }}>
          <Button
            fullWidth
            variant="outlined"
            startIcon={<Plus size={ICON_SIZES.md} strokeWidth={ICON_STROKE} />}
            onClick={() => {
              onNewConversation();
              onClose();
            }}
          >
            New Conversation
          </Button>
        </Box>

        {/* Conversation List */}
        <List sx={{ flex: 1, overflow: 'auto' }}>
          {conversations.length === 0 ? (
            <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
              <Typography variant="body2">No conversations yet</Typography>
            </Box>
          ) : (
            conversations.map((conv) => (
              <ListItemButton
                key={conv.id}
                selected={conv.id === currentConversationId}
                onClick={() => {
                  onSelectConversation(conv.id);
                  onClose();
                }}
              >
                <ListItemText primary={conv.title} secondary={conv.updatedAt.toLocaleDateString()} primaryTypographyProps={{ noWrap: true }} />
              </ListItemButton>
            ))
          )}
        </List>
      </Box>
    </Drawer>
  );
}
